// @ts-nocheck
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import iconChevronDown from "assets/icons/chevron-down.svg";
import iconNotificationDanger from "assets/icons/notification-danger.svg";
import iconNotificationInfo from "assets/icons/notification-info.svg";
import iconNotificationWarning from "assets/icons/notification-warning.svg";
import _ from "lodash";
import moment from "moment-timezone";

import { Container } from "components/ui-kit/styled-templates";

import UserApi from "api/user-api";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";
import UserQuestionnairesPanel from "../questionnaires/panels/UserQuestionnairesPanel";
import { renderMessage } from "../chat/panels/RoomChatPanel";

type Notification = {
    id: string;
    type: "warning" | "danger" | "info";
    text: string;
    name: string;
    timestamp: number;
    refLink?: string;
};

const NotificationsPage = () => {
    useBodyBackground(`white`);
    const { t } = useTranslation();

    let notifications = useStorageListener("notifications", []) as Notification[];
    console.log('notifications = ', notifications);
    if (notifications != undefined){
        notifications = notifications.sort((a, b) => b.timestamp - a.timestamp);
        notifications = notifications.filter(x => (x.text != undefined && x.text != ''));
    }

    const [openedNotificationsIds, setOpenedNotificationsIds] = useState<Notification["id"][]>([]);

    const toggleNotification = (notificationId: Notification["id"]) => () => {
        setOpenedNotificationsIds(
            [...openedNotificationsIds, notificationId].filter((item) =>
                item === notificationId ? !openedNotificationsIds.includes(notificationId) : true,
            ),
        );
    };

    useEffect(() => {
        UserApi.getNotifications();
    }, []);

    return (
        <Container extra="margin: 56px 0; align-items: flex-start;" className="flex flex-col">

            <UserQuestionnairesPanel/>

            <h1 className="mb-4">Уведомления</h1>
            {notifications.length === 0 && <p>{t("selectEmpty")}</p>}
            {notifications.map((notification, index, self) => {
                const icon = {
                    danger: iconNotificationDanger,
                    warning: iconNotificationWarning,
                    info: iconNotificationInfo,
                }[_.get(notification, "type", "")];
                const isOpened = openedNotificationsIds.includes(_.get(notification, "id", ""));
                return (
                    <Fragment key={_.get(notification, "id", "")}>
                        <div className="flex flex-row w-full items-center gap-2" onClick={toggleNotification(_.get(notification, "id", ""))}>
                            <div className="flex flex-col items-start justify-center w-full gap-2">
                                <div className="flex flex-row justify-between gap-2 w-full">
                                    <div className="flex flex-row gap-2">
                                        <img src={icon} alt="Notification icon" className="w-6 h-6" />
                                        <span className="text-slate-700 font-medium text-xl">{renderMessage(notification.name || '')}</span>
                                    </div>
                                    <span className="text-slate-500">{moment(_.get(notification, "timestamp", 0)).format("HH:mm DD/MM/YYYY")}</span>
                                </div>
                                <p className="text-slate-500 text-md">
                                    {renderMessage(notification.text || '')}
                                    {/*{_.get(notification, "text", "").slice(0, isOpened ? _.get(notification, "text", "").length : 100)}*/}
                                    {isOpened ? "" : ""}
                                </p>

                                {notification?.bookingId && (
                                    <div className={'my-1'} >
                                        <a target={'_blank'}  href={`/preview-booking/${notification?.bookingId}`} className="text-blue-500">
                                            перейти к бронированию
                                        </a>
                                    </div>
                                )}

                                {notification?.eventBookingId && (
                                    <div className={'my-1'} >
                                        <a target={'_blank'}  href={`/event-request-preview/${notification?.eventBookingId}`} className="text-blue-500">
                                            перейти к бронированию события
                                        </a>
                                    </div>
                                )}



                            </div>
                            <img
                                src={iconChevronDown}
                                alt="Show more arrow"
                                className={`w-6 h-6 cursor-pointer transform transition-transform ${isOpened ? `rotate-180` : ``}`}
                            />
                        </div>
                        {index < self.length - 1 && <hr className="w-full my-4" />}
                    </Fragment>
                );
            })}

        </Container>
    );
};

export default NotificationsPage;
